import green from 'material-ui/colors/green';
import grey from 'material-ui/colors/grey';
import lime from 'material-ui/colors/lime';
import yellow from 'material-ui/colors/yellow';
import red from 'material-ui/colors/red';

export const builderStyles = (theme) => ({
    // General
    root: theme.mixins.gutters({
        padding: '25px 0',
        marginTop: 10,
        marginBottom: 10,
        position: 'relative',
    }),
    marginTop0: {
        marginTop: 0,
    },
    hasErrors: {
        color: red[500],
    },
    buttonWrapper: {
        marginTop: theme.spacing.unit,
        position: 'relative',
    },
    progressIcon: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        marginTop: -12,
        marginLeft: -30,
    },
    disabledSaveButton: {
        width: 150,
    },
    saveButton: {
        width: 150,
        backgroundColor: '#00583d',
        '&:hover': {
            backgroundColor: '#003625',
        },
    },
    buttonPreview: {
        width: 150,
        marginLeft: '10px',
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    discardButton: {
        width: 150,
        marginLeft: '10px',
    },
    cloneButton: {
        marginLeft: '10px',
        backgroundColor: '#1976d2',
        color: '#FFFFFF',
        '&:hover': {
            backgroundColor: '#175796',
        },
    },
    darkGreen: {
        padding: 6,
        backgroundColor: green[700],
    },
    green: {
        padding: 6,
        backgroundColor: green[200],
    },
    red: {
        padding: 6,
        backgroundColor: red[300],
    },
    warning: {
        padding: 6,
        backgroundColor: '#f8ffd2',
        position: 'relative',
    },
    saveWarning: {
        zIndex: 1,
    },
    card1: theme.mixins.gutters({
        marginBottom: theme.spacing.unit * 0.5,
        marginTop: theme.spacing.unit * 0.5,
    }),

    marginBottom10: {
        marginBottom: theme.spacing.unit,
    },

    opacityBackdrop: {
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
    },

    // Sections
    new: {
        backgroundColor: yellow[100],
        '& .textBlockPlaceholder .text-row': {
            background: '#FFCB82 !important',
        },
    },
    chipWebsite: {
        margin: theme.spacing.unit,
    },
    chipWebsiteBackground: {
        margin: theme.spacing.unit,
    },
    chipParentPage: {
        margin: theme.spacing.unit,
        minHeight: '100%',
    },
    chipPageTagsVersions: {
        margin: theme.spacing.unit,
        height: '100%',
        padding: theme.spacing.unit,
    },
    chipPageTags: {
        margin: theme.spacing.unit,
        height: '100%',
        padding: theme.spacing.unit,
    },
    chipPageTagsDnd: {
        margin: theme.spacing.unit,
        height: '100%',
        padding: theme.spacing.unit,
    },
    chipPageTagsLabel: {
        whiteSpace: 'normal',
        display: 'inline-flex',
    },
    contentPageTagsList: {
        margin: 0,
        paddingLeft: 30,
    },
    chipPageWebsite: {
        margin: theme.spacing.unit,
        color: '#00583d',
        fontWeight: 600,
    },
    chipTextGreen: {
        color: '#00583d',
        fontWeight: 600,
    },
    snackbar: {
        maxWidth: '100%',
        minWidth: '100%',
        marginBottom: '10px',
        backgroundColor: grey[500],
    },
    touched: {
        backgroundColor: grey[200],
        '& .textBlockPlaceholder .text-row': {
            background: '#ffffff !important',
        },
    },
    pbSectionTitle: {
        color: theme.palette.primary[500],
    },
    pbSectionBody: {
        color: theme.palette.text,
    },
    pbSectionCaption: {
        marginBottom: 15,
    },
    pbSectionCaptionChip: {
        marginRight: 30,
    },
    pbSectionDrag: {
        position: 'absolute',
        top: 15,
        cursor: 'pointer',
        marginTop: 13,
        width: '108px',
        right: '-70px',
    },
    pbSortSectionActions: {
        width: 40,
        position: 'absolute',
        right: 10,
        bottom: 0,
        cursor: 'pointer',
    },
    pbSectionActions: {
        width: 115,
        position: 'absolute',
        right: 10,
        bottom: 0,
        cursor: 'pointer',
    },
    pbSortSectionActionsDelete: {
        width: 80,
        float: 'right',
        bottom: 0,
        right: -55,
        position: 'absolute',
    },
    pbSection: {},
    selectedVersionText: {
        paddingLeft: 0,
    },
    compareMetaSection: {
        marginTop: 0,
    },
    pbMetaSectionComparePopup: {
        padding: 5,
        lineHeight: 1.2,
    },
    pbSectionComparePopup: {
        height: 300,
        padding: 5,
        overflowY: 'auto',
        overflowX: 'hidden',
        lineHeight: 1.2,
    },
    pbSectionComparePopupReadonly: {
        padding: 10,
    },
    pbSectionReadonly: {
        backgroundColor: lime[50],
        '& h2': {
            color: grey[400],
            padding: 0,
            margin: 0,
        },
        '& .body': {
            color: grey[400],
        },
    },
    dialogActionsBtn: {
        margin: '8px 19px',
    },
    selectMenuItem: {
        fontSize: '14px',
        padding: '0 15px',
    },
    documentIcon: {
        width: 25,
        height: 25,
        color: '#940000',
    },
    messageNoEntries: {
        fontSize: '18px',
        height: '200px',
        textAlign: 'center',
        paddingTop: '85px',
    },

    // Elements

    pbElement: {
        background: theme.palette.background.default,
        padding: 10,
        marginBottom: 10,
        cursor: 'grab',
        borderRadius: 3,
        '&:active': {
            cursor: 'grabbing',
        },
        '&:hover': {
            background: 'linear-gradient(45deg, #ffffff 10%, #EEEEEE 100%)',
        },
        '& img': {
            float: 'left',
        },
    },
    pbElementImage: {
        float: 'left',
        marginRight: 25,
        width: 37,
    },
    pbElementText: {
        fontSize: 16,
        margin: 0,
        height: 28,
    },
    shadow: {
        boxShadow: '0 1px 5px 0px rgba(0, 0, 0, .2)',
    },
    row: {
        display: 'flex',
    },
    bigAvatar: {
        width: 60,
        height: 60,
        display: 'inline-flex',
        margin: '0px 5px 10px 0px',
    },
    locationGroup: {
        marginTop: '20px !important',
    },
    sectionTitle: {
        margin: theme.spacing.unit,
    },
    sectionTitleChip: {
        margin: theme.spacing.unit,
    },
    rootVersionsTable: {
        width: '100%',
        marginTop: 0,
        overflowX: 'auto',
    },
    enabledCheckbox: {
        color: 'rgba(0, 88, 61, 0.61)',
    },
    disabledCheckbox: {
        color: 'rgba(211, 47, 47, 0.62)',
    },
    backButton: {
        marginTop: 15,
    },
    lead: {
        fontSize: '18px',
        padding: '10px 0 0 10px',
    },
    mandatoryText: {
        margin: '17px 5px 0 0',
        float: 'right',
    },
    textImageUploading: {
        marginTop: '-19px',
        textAlign: 'center',
        position: 'relative',
        color: '#fff',
        fontWeight: 500,
        zIndex: 2,
    },
    paperImageUploading: {
        height: 20,
    },
});



// WEBPACK FOOTER //
// ./src/containers/builder/style/builder.js